import React from 'react';
import PropTypes from 'prop-types';
import { TabContent } from '@saviynt/design-system';
import ThemeCard from '../../Components/ThemeCard/ThemeCard';
import { getDisplayedTheme, message } from '../../utils/helper';

const ThemesTab = ({
  intl,
  classes,
  customThemes,
  customThemesCount,
  saviyntThemes,
  saviyntThemesCount,
  selectedTheme,
  activeTheme,
  themeSelection,
  CreateThemeButton,
  activeTab,
}) => (
  <TabContent value={activeTab} tabValue="bc_tab_themes">
    {customThemesCount > 0 && (
      <div className={classes.themeGroup}>
        <div
          className={`${classes.subSectionHeader} ${classes.dFlex} ${classes.dFlexSpaceBetween} ${classes.dFlexAlignCenter}`}
        >
          <h5 className={`${classes.subSectionHeaderText} ${classes.m_0}`}>
            {`${message(intl, 'UI.Gen2.Admin.Branding.Theme.Type.Custom')} ${
              customThemesCount && `(${customThemesCount})`
            }`}
          </h5>
          <CreateThemeButton />
        </div>
        <div className={classes.themeGrid}>
          {Object.entries(customThemes).map(([themeName, themes]) => (
            <ThemeCard
              key={themeName}
              data={themes}
              handleSelection={themeSelection}
              isSelected={
                selectedTheme &&
                getDisplayedTheme(selectedTheme)?.name === getDisplayedTheme(themes)?.name
              }
              activeTheme={activeTheme}
              activeLabel={message(intl, 'UI.Gen2.Admin.Branding.Theme.ThemeGrid.Active.Tooltip')}
              intl={intl}
            />
          ))}
        </div>
      </div>
    )}
    {saviyntThemesCount > 0 && (
      <div>
        <div
          className={`${classes.subSectionHeader} ${classes.dFlex} ${classes.dFlexSpaceBetween} ${classes.dFlexAlignCenter}`}
        >
          <h5 className={`${classes.subSectionHeaderText} ${classes.m_0}`}>
            {`${message(intl, 'UI.Gen2.Admin.Branding.Theme.Type.OOTB')} ${
              saviyntThemesCount && `(${saviyntThemesCount})`
            }`}
          </h5>
          {!(customThemesCount > 0) && <CreateThemeButton />}
        </div>
        <div className={classes.themeGrid}>
          {Object.entries(saviyntThemes).map(([themeName, themes]) => (
            <ThemeCard
              key={themeName}
              data={themes}
              handleSelection={themeSelection}
              isSelected={
                selectedTheme &&
                getDisplayedTheme(selectedTheme)?.name === getDisplayedTheme(themes)?.name
              }
              activeTheme={activeTheme}
              activeLabel={message(intl, 'UI.Gen2.Admin.Branding.Theme.ThemeGrid.Active.Tooltip')}
              intl={intl}
            />
          ))}
        </div>
      </div>
    )}
  </TabContent>
);

ThemesTab.propTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }).isRequired,
  classes: PropTypes.shape({}).isRequired,
  customThemes: PropTypes.shape({}).isRequired,
  customThemesCount: PropTypes.number.isRequired,
  saviyntThemes: PropTypes.shape({}).isRequired,
  saviyntThemesCount: PropTypes.number.isRequired,
  selectedTheme: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  activeTheme: PropTypes.shape({}).isRequired,
  themeSelection: PropTypes.func.isRequired,
  CreateThemeButton: PropTypes.elementType.isRequired,
  activeTab: PropTypes.string.isRequired,
};

export default ThemesTab;
